import React, { useEffect, useState } from "react";
import { Form, Input, Button, Modal, message } from "antd";
import {
  UserOutlined,
  MailOutlined,
  ApartmentOutlined,
  EnvironmentOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import saveIcon from "../../../Assets/Icons/save changes.svg";
import "./style.css";
import { editUserProfile, getUserProfile } from "../../../API/userProfile";

const EditProfile = () => {
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [profileData, setProfileData] = useState({});

  const fetchUserProfileInfo = async () => {
    try {
      setLoading(true);

      const response = await getUserProfile();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || {};
        setProfileData(data);
      } else {
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      message.error("Failed to fetch user");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfileInfo();
  }, []);

  useEffect(() => {
    if (profileData) {
      form.setFieldsValue(profileData);
    }
  }, [profileData]);

  const handleSaveClick = (values) => {
    setFormValues(values);
    setConfirmModalVisible(true);
  };

  const handleConfirmSave = async () => {
    try {
      setLoadingButton(true);
      const response = await editUserProfile(formValues);
      if (Math.floor(response?.status / 100) === 2) {
        message.success("Profile updated successfully!");
      } else {
        message.error(response?.message);
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoadingButton(false);
    }

    setConfirmModalVisible(false);
  };

  const handleResetForm = () => {
    form.resetFields();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="page">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
          Back
        </Button>
      </div>

      <div className="edit-profile">
        <div className="edit-card">
          <div className="header">Edit Profile</div>
          <div className="border"></div>
          <div className="form">
            <Form
              form={form}
              name="editProfile"
              layout="vertical"
              autoComplete="off"
              initialValues={profileData}
              onFinish={handleSaveClick}
            >
              <div className="item" style={{ display: "flex", gap: "16px" }}>
                <Form.Item
                  label="Full Name"
                  name="name"
                  style={{ flex: 1 }}
                  rules={[
                    { required: true, message: "Please enter your full name!" },
                  ]}
                >
                  <Input
                    placeholder="Enter your full name"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
              </div>

              <div style={{ display: "flex", gap: "16px" }}>
                <Form.Item
                  label="Company Name"
                  name="company_name"
                  style={{ flex: 1 }}
                  rules={[{ required: true, message: "Enter company name!" }]}
                >
                  <Input
                    placeholder="Company name"
                    prefix={<ApartmentOutlined />}
                  />
                </Form.Item>

                <Form.Item
                  label="Phone Number"
                  name="phone_number"
                  style={{ flex: 1 }}
                  rules={[{ required: true, message: "Enter phone number!" }]}
                >
                  <PhoneInput country={"us"} inputStyle={{ width: "100%" }} />
                </Form.Item>
              </div>

              <Form.Item
                label="Business Address"
                name="business_address"
                rules={[{ required: true, message: "Enter business address!" }]}
              >
                <Input
                  placeholder="Enter business address"
                  prefix={<EnvironmentOutlined />}
                />
              </Form.Item>

              <Form.Item>
                <div className="form-footer">
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={handleResetForm}
                  >
                    Cancel
                  </button>

                  <Button
                    className="save-btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>

        <Modal
          className="logout-modal"
          open={confirmModalVisible}
          title={
            <div className="modal-text">
              <img
                src={saveIcon}
                alt="logout"
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 8,
                  backgroundColor: "#4928FD1A",
                }}
              />
              <div className="logout-text">
                <span>Save Changes?</span>
                <p>
                  You have made changes to your profile details? Do you want to
                  save these changes?
                </p>
              </div>
            </div>
          }
          onOk={handleConfirmSave}
          confirmLoading={loadingButton}
          onCancel={() => setConfirmModalVisible(false)}
          okText="Save Changes"
          cancelText="Cancel"
          centered
        ></Modal>
      </div>
    </div>
  );
};

export default EditProfile;
